'use client';
import useUserProfile from '@/hooks/useUserProfile';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import Avatar from '@ui/Avatar';
import { ProfileTypes } from 'constants/profileType.constant';
import PropTypes from 'prop-types';
import React from 'react';

function ProfileAvatar(props) {
  const {
    className = '',
    customOrg = null,
    customProfileType = null,
    ...rest
  } = props;
  const userProfile = useUserProfile();
  const profileType = userProfile.selectedProfile;
  const customName =
    customProfileType === ProfileTypes.Individual
      ? userProfile.fullName
      : customOrg?.name;
  const customAvatar =
    customProfileType === ProfileTypes.Individual
      ? userProfile.avatar
      : customOrg?.logo_url || customOrg?.logoUrl;
  let name =
    profileType === ProfileTypes.Individual
      ? userProfile.fullName
      : userProfile.activeCommunity.name;
  let avatar =
    profileType === ProfileTypes.Individual
      ? userProfile.avatar
      : userProfile.activeCommunity.logoUrl;

  if (customProfileType) {
    name = customName;
    avatar = customAvatar;
  }

  return (
    <Avatar
      src={getQualifiedImageUrl(avatar)}
      alt={name}
      className={className}
      profile={profileType === ProfileTypes.Individual ? 'user' : 'npo'}
      {...rest}
    />
  );
}

ProfileAvatar.propTypes = {
  className: PropTypes.string,
};

export default ProfileAvatar;
